var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.data.value)?_c('vx-no-info-dash'):_c('div',_vm._l((_vm.data.value),function(value,key){return _c('div',{key:key},[_vm._v(" "+_vm._s(key)+": "+_vm._s(value)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }